import { useQuery } from '@tanstack/react-query';
import type { api } from '@udm/contracts';
import { fetchSites } from '../../api/client';

type Kind = api.SiteKind;

export const SITES_KEY = ['admin', 'sites'] as const;

/** Kinds allowed below a parent (mirrors the database hierarchy trigger, migration 0010). */
export const childKinds = (parent: Kind | null): Kind[] =>
  parent === null
    ? ['organization']
    : parent === 'organization'
      ? ['locality', 'other']
      : parent === 'other'
        ? ['other']
        : ['zone', 'other'];

export function useAdminSites() {
  return useQuery({ queryKey: SITES_KEY, queryFn: fetchSites, staleTime: 60_000 });
}
